import {Injectable} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Injectable({providedIn: 'root'})

export class LanguageService {
    get isArabic() {
      return this.translate.currentLang === 'ar';
    }
    constructor(private translate: TranslateService) {}
}
